import React, { memo, useCallback } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

import Traductor from '../../Traductor';
import '../../../css/components/batches/TrolleyFooter.css';

const TrolleyFooter = ({ disabled, onSubmit, onClose, footer, loading }) => {
    const t = new Traductor();

    const renderSpinner = useCallback(() => {
        if (loading) {
            return (
                <div
                    className="c-spinner c-spinner--small"
                    aria-live="polite"
                    aria-busy="true"
                >
                    <div className="c-spinner__loader">
                        <span className="c-spinner__element"></span>
                        <span className="c-spinner__element"></span>
                        <span className="c-spinner__element"></span>
                        <span className="c-spinner__element"></span>
                        <span className="c-spinner__element"></span>
                        <span className="c-spinner__element"></span>
                        <span className="c-spinner__element"></span>
                        <span className="c-spinner__element"></span>
                    </div>
                </div>
            );
        }
    }, [loading]);

    if (footer) {
        return (
            <div className="u-pt-none">
                <h5 className="u-mb-none" style={{ textTransform: 'initial' }}>
                    {footer.label}
                </h5>
                <p className="u-mb-none" style={{ textTransform: 'initial' }}>
                    {footer.text}
                </p>
                <div
                    id="c-form-buttons"
                    className="c-form-field o-button-container u-mt-large"
                >
                    <button
                        className="c-btn c-btn--full c-btn--secondary  c-header-profile-dropdown__link"
                        onClick={onClose}
                    >
                        <span className="c-btn__text">
                            {t.getTraduction('Close')}
                        </span>
                    </button>
                    <button
                        className="c-btn c-btn--full"
                        disabled={disabled || footer.disabled || loading}
                        aria-disabled={disabled}
                        onClick={footer.callback}
                        type="submit"
                    >
                        <span className="c-btn__text">
                            {t.getTraduction('AddVehicles')}
                        </span>
                        {renderSpinner()}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <Formik
            initialValues={{
                name: '',
            }}
            onSubmit={onSubmit}
            validationSchema={Yup.object().shape({
                name: Yup.string().required(
                    t.getTraduction('TrolleyFormNameRequired')
                ),
            })}
        >
            {({ values, handleSubmit, setFieldValue, errors, isValid }) => (
                <form
                    action="#"
                    className="u-pt-none"
                    style={{ lineHeight: 'normal' }}
                >
                    <div className="c-form-field">
                        <label
                            htmlFor={t.getTraduction(`TrolleyFormNameLabel`)}
                            className="c-form-field__label"
                            style={{ lineHeight: 'normal' }}
                        >
                            {t.getTraduction(`TrolleyFormNameLabel`)}
                        </label>
                        <div className="c-form-field__box">
                            <div className="c-input  ">
                                <input
                                    id={t.getTraduction(`TrolleyFormNameLabel`)}
                                    className="c-input__input"
                                    name="name"
                                    type="text"
                                    placeholder={t.getTraduction(
                                        `TrolleyFormNamePlaceholder`
                                    )}
                                    onChange={e =>
                                        setFieldValue('name', e.target.value)
                                    }
                                    value={values.name}
                                    disabled={disabled}
                                />
                            </div>
                            <p className="c-error-message">{errors.name}</p>
                        </div>
                    </div>
                    <div
                        id="c-form-buttons"
                        className="c-form-field o-button-container u-mt-large"
                    >
                        <button
                            className="c-btn c-btn--full c-btn--secondary  c-header-profile-dropdown__link"
                            onClick={onClose}
                        >
                            <span className="c-btn__text">
                                {t.getTraduction('Close')}
                            </span>
                        </button>
                        <button
                            className="c-btn c-btn--full"
                            disabled={disabled || loading}
                            aria-disabled={disabled || loading}
                            onClick={handleSubmit}
                            type="submit"
                        >
                            <span className="c-btn__text">
                                {t.getTraduction('CreateBatch')}
                            </span>
                            {renderSpinner()}
                        </button>
                    </div>
                </form>
            )}
        </Formik>
    );
};

TrolleyFooter.propTypes = {
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    footer: PropTypes.shape({
        label: PropTypes.string,
        text: PropTypes.string,
        callback: PropTypes.func,
        disabled: PropTypes.any,
    }),
};

export default memo(TrolleyFooter);
